import React from "react";
import { Card, CardContent, Typography, IconButton, Box } from "@mui/material";
import {
  ArrowBackIos,
  ArrowForwardIos,
} from "@mui/icons-material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import color from "../utils/Colors";

interface CourseVisibilityCardProps {
  data: { name: string; visibility: number }[];
  periodLabel: string;
  onPeriodChange: (direction: "previous" | "next") => void;
}

const CourseVisibilityCard: React.FC<CourseVisibilityCardProps> = ({
  data,
  periodLabel,
  onPeriodChange,
}) => {
  return (
    <Card
      sx={{
        backgroundColor: color.firstColor,
        color: "white",
        borderRadius: "10px",
        padding: "20px",
        width: "350px",
        height: "350px",
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            Course Visibility
          </Typography>
          <Box display="flex" alignItems="center">
            <IconButton
              size="small"
              sx={{ color: "white" }}
              onClick={() => onPeriodChange("previous")}
            >
              <ArrowBackIos fontSize="small" />
            </IconButton>
            <Typography variant="body2">{periodLabel}</Typography>
            <IconButton
              size="small"
              sx={{ color: "white" }}
              onClick={() => onPeriodChange("next")}
            >
              <ArrowForwardIos fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ height: 250, marginTop: 2, ml: "-15px" }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="white" />
              <XAxis dataKey="name" stroke="white" />
              <YAxis stroke="white" />
              <Tooltip
            contentStyle={{
              backgroundColor: color.firstColor,
              border: "solid 1.5px white",
              borderRadius:'4px',
              color: "white",
            }}
          />
              <Line
                type="monotone"
                dataKey="visibility"
                stroke="#ffffff"
                strokeWidth={3}
                dot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CourseVisibilityCard;
